import LRUCacheNode from '../LRUNode/index.js';

var DEFAULT_SIZE = 10;
var LRU = function () {
  function LRU(limit) {
    if (limit === void 0) {
      limit = DEFAULT_SIZE;
    }
    this.head = null;
    this.tail = null;
    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cacheMap = new Map();
  }
  Object.defineProperty(LRU.prototype, "length", {
    get: function get() {
      return this.size;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LRU.prototype, "first", {
    get: function get() {
      var _a;
      return (_a = this.head) === null || _a === void 0 ? void 0 : _a.value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LRU.prototype, "last", {
    get: function get() {
      var _a;
      return (_a = this.tail) === null || _a === void 0 ? void 0 : _a.value;
    },
    enumerable: false,
    configurable: true
  });
  LRU.prototype.keys = function () {
    return Array.from(this.cacheMap.keys());
  };
  LRU.prototype.values = function () {
    return Array.from(this.cacheMap.values()).map(function (node) {
      return node.value;
    });
  };
  LRU.prototype.has = function (key) {
    return this.cacheMap.has(key);
  };
  LRU.prototype.set = function (key, value) {
    var _a;
    var existingNode = this.cacheMap.get(key);
    if (existingNode) {
      this.detach(existingNode);
      this.size--;
    } else if (this.size === this.limit) {
      if ((_a = this.tail) === null || _a === void 0 ? void 0 : _a.key) {
        this.cacheMap["delete"](this.tail.key);
        this.detach(this.tail);
      }
      this.size--;
    }
    if (!this.head) {
      this.head = this.tail = new LRUCacheNode(key, value);
    } else {
      var node = new LRUCacheNode(key, value, this.head);
      this.head.prev = node;
      this.head = node;
    }
    this.cacheMap.set(key, this.head);
    this.size++;
  };
  LRU.prototype.read = function (key) {
    var existingNode = this.cacheMap.get(key);
    if (existingNode) {
      var value = existingNode.value;
      if (this.head !== existingNode) {
        this.set(key, value);
      }
      return value;
    }
    console.warn("Item not available in cache for key ".concat(key));
  };
  LRU.prototype.detach = function (node) {
    if (node.prev !== null) {
      node.prev.next = node.next;
    } else {
      this.head = node.next;
    }
    if (node.next !== null) {
      node.next.prev = node.prev;
    } else {
      this.tail = node.prev;
    }
  };
  LRU.prototype.clear = function () {
    this.head = null;
    this.tail = null;
    this.size = 0;
    this.cacheMap = new Map();
  };
  return LRU;
}();

export { LRU as default };
//# sourceMappingURL=index.js.map
